/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Purchase_Insufficient_Gems_ContextInputs */

const en_dialog_purchase_insufficient_gems_context = /** @type {(inputs: Dialog_Purchase_Insufficient_Gems_ContextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You need more Time Crystals to unlock this.`)
};

const ar_dialog_purchase_insufficient_gems_context = /** @type {(inputs: Dialog_Purchase_Insufficient_Gems_ContextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تحتاج إلى المزيد من بلورات الزمن لفتح هذا.`)
};

const de_dialog_purchase_insufficient_gems_context = /** @type {(inputs: Dialog_Purchase_Insufficient_Gems_ContextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du brauchst mehr Zeitkristalle, um dies freizuschalten.`)
};

const es_dialog_purchase_insufficient_gems_context = /** @type {(inputs: Dialog_Purchase_Insufficient_Gems_ContextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Necesitas más cristales de tiempo para desbloquear esto.`)
};

const fr_dialog_purchase_insufficient_gems_context = /** @type {(inputs: Dialog_Purchase_Insufficient_Gems_ContextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il vous faut plus de cristaux temporels pour débloquer ceci.`)
};

const it_dialog_purchase_insufficient_gems_context = /** @type {(inputs: Dialog_Purchase_Insufficient_Gems_ContextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ti servono più Cristalli del Tempo per sbloccarlo.`)
};

const ja_dialog_purchase_insufficient_gems_context = /** @type {(inputs: Dialog_Purchase_Insufficient_Gems_ContextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アンロックするには、時の結晶がさらに必要です。`)
};

const ko_dialog_purchase_insufficient_gems_context = /** @type {(inputs: Dialog_Purchase_Insufficient_Gems_ContextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`잠금을 해제하려면 타임 크리스탈이 더 필요합니다.`)
};

const pt_br_dialog_purchase_insufficient_gems_context = /** @type {(inputs: Dialog_Purchase_Insufficient_Gems_ContextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você precisa de mais Cristais do Tempo para desbloquear isto.`)
};

const ru_dialog_purchase_insufficient_gems_context = /** @type {(inputs: Dialog_Purchase_Insufficient_Gems_ContextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вам нужно больше кристаллов времени, чтобы разблокировать это.`)
};

const th_dialog_purchase_insufficient_gems_context = /** @type {(inputs: Dialog_Purchase_Insufficient_Gems_ContextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คุณต้องมีคริสตัลแห่งกาลเวลามากกว่านี้เพื่อปลดล็อก`)
};

const tr_dialog_purchase_insufficient_gems_context = /** @type {(inputs: Dialog_Purchase_Insufficient_Gems_ContextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bunu açmak için daha fazla Zaman Kristaline ihtiyacın var.`)
};

const zh_cn_dialog_purchase_insufficient_gems_context = /** @type {(inputs: Dialog_Purchase_Insufficient_Gems_ContextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你需要更多时光宝石才能解锁。`)
};

const zh_tw_dialog_purchase_insufficient_gems_context = /** @type {(inputs: Dialog_Purchase_Insufficient_Gems_ContextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你需要更多時光寶石才能解鎖。`)
};

/**
* | output |
* | --- |
* | "You need more Time Crystals to unlock this." |
*
* @param {Dialog_Purchase_Insufficient_Gems_ContextInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_purchase_insufficient_gems_context = /** @type {((inputs?: Dialog_Purchase_Insufficient_Gems_ContextInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Purchase_Insufficient_Gems_ContextInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_purchase_insufficient_gems_context(inputs)
	if (locale === "ar") return ar_dialog_purchase_insufficient_gems_context(inputs)
	if (locale === "de") return de_dialog_purchase_insufficient_gems_context(inputs)
	if (locale === "es") return es_dialog_purchase_insufficient_gems_context(inputs)
	if (locale === "fr") return fr_dialog_purchase_insufficient_gems_context(inputs)
	if (locale === "it") return it_dialog_purchase_insufficient_gems_context(inputs)
	if (locale === "ja") return ja_dialog_purchase_insufficient_gems_context(inputs)
	if (locale === "ko") return ko_dialog_purchase_insufficient_gems_context(inputs)
	if (locale === "pt_br") return pt_br_dialog_purchase_insufficient_gems_context(inputs)
	if (locale === "ru") return ru_dialog_purchase_insufficient_gems_context(inputs)
	if (locale === "th") return th_dialog_purchase_insufficient_gems_context(inputs)
	if (locale === "tr") return tr_dialog_purchase_insufficient_gems_context(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_purchase_insufficient_gems_context(inputs)
	return zh_tw_dialog_purchase_insufficient_gems_context(inputs)
});